import React from "react";
import { Modal } from 'react-bootstrap';
import { GetUsage } from "../get_usage";
import type { ChooseDataSourceModalProps } from '../types';

export const ChooseDataSourceModal: React.FC<ChooseDataSourceModalProps> = ({
    show,
    handleClose,
}) => {
    
    return (
        <Modal size="lg" show={show} onHide={() => { handleClose() }}>
            <Modal.Body>
                <GetUsage handleClose={()=>{handleClose();console.log('GetUsage')}} />
            </Modal.Body>
        </Modal>
    )
}